var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"yuri-icon far",class:[_vm.icon, `color-${_vm.color}`],style:({fontSize: _vm.fontSize + 'px'})})
}
var staticRenderFns = []

export { render, staticRenderFns }